import { render } from "./ContactBookView.vue?vue&type=template&id=5b0aebce"
import script from "./js/contactBookView.js?vue&type=script&lang=js&external"
export * from "./js/contactBookView.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__